<ng-container *transloco="let translate">
	<ng-template #collapsedBarTpl let-user="user">
		@if (
			{
				activeRouteClass: 'active',
			};
			as vm
		) {
			<div class="gap-0.25 w-full flex flex-col items-start box-border">
				<a
					[routerLink]="['/', 'home', 'dashboard']"
					[routerLinkActive]="vm.activeRouteClass"
					[routerLinkActiveOptions]="{ exact: true }"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.home')"
				>
					<i ngProjectAs="[icon]" class="icon-home"></i>
				</a>
				<a
					[routerLink]="['/', 'home', 'chat']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.ai_chats')"
				>
					<i ngProjectAs="[icon]" class="icon-sparks-AI"></i>
				</a>
				@if (showMyGenie) {
					<a
						[routerLink]="['/', 'home', 'mygenie']"
						[routerLinkActive]="vm.activeRouteClass"
						uiNewButtonIcon
						[tooltip]="translate('home.side_navigation.mygenie')"
					>
						<i ngProjectAs="[icon]" class="icon-widget"></i>
					</a>
				}
				<a
					[routerLink]="['/', 'home', 'search']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.knowledge_base')"
				>
					<i ngProjectAs="[icon]" class="icon-knowledge-base"></i>
				</a>
				<a
					[routerLink]="['/', 'home', 'integrations']"
					[routerLinkActive]="vm.activeRouteClass"
					uiNewButtonIcon
					[tooltip]="translate('home.side_navigation.integrations')"
				>
					<i ngProjectAs="[icon]" class="icon-integrations"></i>
				</a>

				<div #contextLayerAnchor class="flex items-center justify-center">
					<button
						type="button"
						uiNewButtonIcon
						class="context-layer-collapsed-toggle"
						[class.active]="$contextLayerActive()"
						[tooltip]="translate('home.side_navigation.context_layer')"
						(click)="contextLayerMenu?.open(contextLayerAnchor)"
					>
						<i
							ngProjectAs="[icon]"
							class="icon-context"
							[class.text-primary]="$contextLayerActive()"
						></i>
					</button>
				</div>

				<reach-menu #contextLayerMenu [activeSection]="'1'">
					<ng-container
						*reachMenuSection="
							'1';
							desktopType: MenuDesktopType.FLOATING;
							anchor: contextLayerAnchor;
							widthSize: WidthSize.PX240;
							lightBg: true;
							showFooter: true;
							bordered: true;
							forcePosition: 'RIGHT'
						"
					>
						<div class="flex-auto gap-0.5 w-full flex flex-col items-start">
							@if (showTaxonomies) {
								<a
									class="context-layer-menu-item text-body1 w-full px-1 py-0.75 rounded-0.75 hover:bg-standard-hover flex gap-1 items-center fc-500 transition-background duration-200 ease-in-out"
									[routerLink]="['/', 'home', 'taxonomies']"
									[routerLinkActive]="vm.activeRouteClass"
									(click)="contextLayerMenu?.close()"
								>
									<i class="text-sp-2 fc-400 icon-taxonomy-dna"></i>
									<span class="flex-auto">{{
										translate('home.side_navigation.taxonomy')
									}}</span>
								</a>
							}
							<a
								class="context-layer-menu-item text-body1 w-full px-1 py-0.75 rounded-0.75 hover:bg-standard-hover flex gap-1 items-center fc-500 transition-background duration-200 ease-in-out"
								[routerLink]="['/', 'home', 'categories']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="text-sp-2 fc-400 icon-label-tag"></i>
								<span class="flex-auto">{{
									translate('home.side_navigation.node_categories')
								}}</span>
							</a>
							<a
								class="context-layer-menu-item text-body1 w-full px-1 py-0.75 rounded-0.75 hover:bg-standard-hover flex gap-1 items-center fc-500 transition-background duration-200 ease-in-out"
								[routerLink]="['/', 'home', 'properties']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="text-sp-2 fc-400 icon-add-new-property"></i>
								<span class="flex-auto">{{
									translate('home.side_navigation.properties')
								}}</span>
							</a>
							<a
								class="context-layer-menu-item text-body1 w-full px-1 py-0.75 rounded-0.75 hover:bg-standard-hover flex gap-1 items-center fc-500 transition-background duration-200 ease-in-out"
								[routerLink]="['/', 'home', 'relationships']"
								[routerLinkActive]="vm.activeRouteClass"
								(click)="contextLayerMenu?.close()"
							>
								<i class="text-sp-2 fc-400 icon-relationship-type-link"></i>
								<span class="flex-auto">{{
									translate('home.side_navigation.relationship_types')
								}}</span>
							</a>
						</div>
					</ng-container>
				</reach-menu>
			</div>
		}
	</ng-template>

	@if (
		{
			isDesktop: isDesktop$ | async,
			sidenavOpened: sidenavOpened$ | async,
			visible: visible$ | async,
			collapsed: this.sidenavService.collapsed$ | async,
			user: user$ | async,
			activeRouteClass: 'active',
		};
		as vm
	) {
		<mat-drawer-container
			#matDrawerContainer
			[hasBackdrop]="!vm.isDesktop"
			(backdropClick)="onBackdropClick()"
			class="w-full h-full [--mat-sidenav-content-background-color:rgb(var(--color-bg-180-rgb))]"
		>
			<mat-drawer
				#drawer
				[autoFocus]="false"
				[disableClose]="vm.isDesktop"
				class="drawer"
				[class.desktop]="vm.isDesktop"
				[class.collapsed]="vm.collapsed"
				[mode]="vm.isDesktop ? 'side' : 'push'"
				[opened]="vm.isDesktop ? vm.visible : vm.sidenavOpened"
				(openedChange)="onOpenedChange(drawer)"
				(transitionrun)="onDrawerTransitionStart($event)"
				(transitionstart)="onDrawerTransitionStart($event)"
				(transitionend)="onDrawerTransitionEnd($event)"
			>
				<div
					class="w-full h-full fc-800 bg-190 box-border"
					[class.relative]="vm.isDesktop"
					[class.py-1]="vm.isDesktop"
					[class.pl-1]="vm.isDesktop"
				>
					<div
						class="pt-safe-t pb-safe-b pl-safe-l h-full bg-280 box-border overflow-hidden content-container"
						[class.w-full]="!vm.isDesktop"
						[class]="vm.isDesktop ? 'rounded-1.5' : ''"
					>
						<div
							class="w-full h-full flex flex-col items-start justify-start box-border"
						>
							<div
								class="w-full"
								[class.pt-1]="vm.isDesktop"
								[class.pt-2]="!vm.isDesktop"
								[class]="!vm.isDesktop ? 'pl-0.5' : ''"
								[class.pr-1]="!vm.isDesktop"
							>
								<!-- SIDENAV HEADER -->
								<sidenav-header
									class="w-full"
									[class]="
										vm.collapsed ? 'px-0.5' : vm.isDesktop ? 'pl-1' : 'pl-1'
									"
								></sidenav-header>
							</div>
							@if (vm.isDesktop) {
								<div class="flex-none w-full">
									<!-- Collapsed -->
									@if ($menuContentCollapsed()) {
										<div class="px-1 pt-1 mb-0.25 w-full box-border">
											<ng-container
												[ngTemplateOutlet]="collapsedBarTpl"
												[ngTemplateOutletContext]="{ user: vm.user }"
											></ng-container>
										</div>
									}
									<!-- Expanded -->
									@if (!$menuContentCollapsed()) {
										<div
											class="px-1 pt-1 gap-0.25 w-full flex flex-col box-border"
										>
											<div class="w-full flex">
												<a
													[routerLink]="['/', 'home', 'dashboard']"
													[routerLinkActiveOptions]="{ exact: true }"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-full"
												>
													<div
														class="w-full"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-home"
														></i>
														<span class="text-body1">{{
															translate('home.side_navigation.home')
														}}</span>
													</div>
												</a>
											</div>
											<div class="w-full flex">
												<a
													[routerLink]="['/', 'home', 'chat']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-full"
												>
													<div
														class="w-full"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-sparks-AI"
														></i>
														<span class="text-body1">{{
															translate(
																'home.side_navigation.ai_chats'
															)
														}}</span>
													</div>
												</a>
											</div>
											@if (showMyGenie) {
												<div class="w-full flex">
													<a
														[routerLink]="['/', 'home', 'mygenie']"
														[routerLinkActive]="vm.activeRouteClass"
														uiNewButtonBasic
														class="w-full"
													>
														<div
															class="w-full"
															uiNewLayoutIconText="SIZE_XL"
														>
															<i
																ngProjectAs="[icon]"
																class="fc-400 icon-widget"
															></i>
															<span class="text-body1">{{
																translate(
																	'home.side_navigation.mygenie'
																)
															}}</span>
														</div>
													</a>
												</div>
											}
											<div class="w-full flex">
												<a
													[routerLink]="['/', 'home', 'search']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-full"
												>
													<div
														class="w-full"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-knowledge-base"
														></i>
														<span class="text-body1">{{
															translate(
																'home.side_navigation.knowledge_base'
															)
														}}</span>
													</div>
												</a>
											</div>
											<div class="w-full flex">
												<a
													[routerLink]="['/', 'home', 'integrations']"
													[routerLinkActive]="vm.activeRouteClass"
													uiNewButtonBasic
													class="w-full"
												>
													<div
														class="w-full"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-integrations"
														></i>
														<span class="text-body1">{{
															translate(
																'home.side_navigation.integrations'
															)
														}}</span>
													</div>
												</a>
											</div>

											<div class="gap-0.25 w-full flex flex-col">
												<button
													type="button"
													uiNewButtonBasic
													class="w-full context-layer-toggle"
													[class.active]="$contextLayerActive()"
													(click)="toggleContextLayer()"
												>
													<div
														class="w-full"
														uiNewLayoutIconText="SIZE_XL"
													>
														<i
															ngProjectAs="[icon]"
															class="fc-400 icon-context"
															[class.text-primary]="
																$contextLayerActive()
															"
														></i>
														<span class="gap-0.25 flex items-center">
															<span
																class="text-body1"
																(click)="openContextLayer($event)"
																>{{
																	translate(
																		'home.side_navigation.context_layer'
																	)
																}}</span
															>
															<i
																class="flex-none icon-chevron text-icon-s fc-400"
																[class.chevron-down]="
																	$contextLayerExpanded()
																"
																[class.chevron-right]="
																	!$contextLayerExpanded()
																"
															></i>
														</span>
													</div>
												</button>

												<div
													class="context-layer-submenu-list"
													[class.context-layer-submenu-list--collapsed]="
														!$contextLayerExpanded() ||
														vm.collapsed ||
														$submenuEnterCollapsed()
													"
												>
													<div
														class="gap-0.25 w-full flex flex-col overflow-hidden min-h-0"
													>
														@if (showTaxonomies) {
															<div class="w-full flex">
																<a
																	[routerLink]="[
																		'/',
																		'home',
																		'taxonomies',
																	]"
																	[routerLinkActive]="
																		vm.activeRouteClass
																	"
																	uiNewButtonBasic
																	class="w-full sidenav-submenu-item"
																>
																	<div
																		class="w-full"
																		uiNewLayoutIconText="SIZE_L"
																	>
																		<i
																			ngProjectAs="[icon]"
																			class="fc-400 icon-taxonomy-dna text-icon-s"
																		></i>
																		<span class="text-body1">{{
																			translate(
																				'home.side_navigation.taxonomy'
																			)
																		}}</span>
																	</div>
																</a>
															</div>
														}
														<div class="w-full flex">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'categories',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-full sidenav-submenu-item"
															>
																<div
																	class="w-full"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-label-tag text-icon-s"
																	></i>
																	<span class="text-body1">{{
																		translate(
																			'home.side_navigation.node_categories'
																		)
																	}}</span>
																</div>
															</a>
														</div>
														<div class="w-full flex">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'properties',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-full sidenav-submenu-item"
															>
																<div
																	class="w-full"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-add-new-property text-icon-s"
																	></i>
																	<span class="text-body1">{{
																		translate(
																			'home.side_navigation.properties'
																		)
																	}}</span>
																</div>
															</a>
														</div>
														<div class="w-full flex">
															<a
																[routerLink]="[
																	'/',
																	'home',
																	'relationships',
																]"
																[routerLinkActive]="
																	vm.activeRouteClass
																"
																uiNewButtonBasic
																class="w-full sidenav-submenu-item"
															>
																<div
																	class="w-full"
																	uiNewLayoutIconText="SIZE_L"
																>
																	<i
																		ngProjectAs="[icon]"
																		class="fc-400 icon-relationship-type-link text-icon-s"
																	></i>
																	<span class="text-body1">{{
																		translate(
																			'home.side_navigation.relationship_types'
																		)
																	}}</span>
																</div>
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									}
								</div>
							}
							<div
								teleporterHub="home-sidenav"
								class="w-full flex-auto scrollbar-fade overflow-auto"
								[class.sidenav-teleporter-hub--collapsed]="vm.collapsed"
							></div>
							<!-- SIDENAV FOOTER -->
							<div class="p-1 w-full">
								<div class="w-full separator"></div>
							</div>
							@if (vm.isDesktop) {
								<div
									class="sidenav-footer-slot pb-1 w-full box-border"
									[class.px-1]="!vm.collapsed"
								>
									<sidenav-footer class="w-full box-border"></sidenav-footer>
								</div>
							}
						</div>
					</div>
				</div>
			</mat-drawer>
			<mat-drawer-content>
				<div class="overflow-hidden w-full h-full fc-800 bg-190">
					<ng-content></ng-content>
				</div>
			</mat-drawer-content>
		</mat-drawer-container>
	}
</ng-container>
